export const GET_BRAND_USERS = 'GET_BRAND_USERS';
export const CREATE_BRAND_USER = 'CREATE_BRAND_USER';
export const UPDATE_BRAND_USER = 'UPDATE_BRAND_USER';
export const SELECT_BRAND_USER = 'SELECT_BRAND_USER';
export const DELETE_BRAND_USER = 'DELETE_BRAND_USER';
export const SET_IS_LOADING_ACTION = '  SET_IS_LOADING_ACTION';
